// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-site-design .fi-container ui-view {
  display: block;
  height: 100%;
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./Source/app/fi-site-design/fi-site-design.component.scss"],"names":[],"mappings":"AAEQ;EACI,cAAA;EACA,YAAA;EACA,gBAAA;AADZ","sourcesContent":[".fi-site-design {\r\n    .fi-container {\r\n        ui-view {\r\n            display: block;\r\n            height: 100%;\r\n            overflow: hidden;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
